<template>
  <v-container>
    <the-dialog-box
      ref="dialogBox"
      :submit="submit"
      :max-width="1000"
      :submit-btn-text="!isNew ? 'Save' : 'Create'"
      :cancel-btn-text="'Close'"
    >
      <template slot="header">
        <div class="d-flex flex-wrap align-center">
          <span class="mr-3">{{ !isNew ? 'Update' : 'Create' }} Inventory PO Item</span>
          <v-chip
            v-if="inventoryClass !== null"
            class="my-1"
            small
            text-color="white"
            :color="inventoryClass.color"
          >
            {{ inventoryClass.name }}
          </v-chip>
        </div>
      </template>

      <template slot="body">
        <v-row>
          <v-col
            class="pa-3 ma-3"
            :style="{ backgroundColor: isDarkMode ? '' : '#E8F5E9', border: '2px solid rgba(0,0,0,0.2)', borderRadius: '4px'}"
          >
            <v-row>
              <v-col v-if="businessRulesGetBoolean('Inventory Sub Class') && filteredSubClassesList && filteredSubClassesList.length" cols="12" class="pb-0">
                <v-autocomplete
                  v-model="subClasses"
                  label="Sub Classes"
                  :items="filteredSubClassesList"
                  item-text="name"
                  item-value="id"
                  multiple
                  clearable
                >
                  <template #item="{ item }">
                    <v-chip
                      class="mt-1 mb-1 mr-3"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>

                  <template #selection="{ item }">
                    <v-chip
                      class="mt-1 mb-1 mr-3"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                v-if="!isPatioDoorClass"
                cols="12"
                sm="9"
                class="pb-0"
                :class="{ 'pt-0': businessRulesGetBoolean('Inventory Sub Class') && filteredSubClassesList && filteredSubClassesList.length }"
              >
                <v-autocomplete
                  v-if="inventoryClassId == classPaintId"
                  v-model="item.glass_paint_code_id"
                  clearable
                  :items="glassPaintCodes"
                  item-value="id"
                  :loading="loadingInventoryItem"
                  :item-text="(item) => item.code + ': ' + item.description"
                  :rules="[(v) => !!v || 'Paint Code  is required']"
                >
                  <template slot="label">
                    Paint Code<RedAsterisk />
                  </template>
                  <template #item="{ item }">
                    <v-chip
                      class="mt-1 mb-1 mr-3"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      color="#8dbf8d"
                    >
                      PAINT
                    </v-chip><span style="font-weight: bold;">{{ item.code }}</span><span>{{ ': ' + item.description }}</span>
                  </template>
                  <template #selection="{ item }">
                    <v-chip
                      class="mt-1 mb-1 mr-3"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      color="#8dbf8d"
                    >
                      PAINT
                    </v-chip><span style="font-weight: bold;">{{ item.code }}</span><span>{{ ': ' + item.description }}</span>
                  </template>
                </v-autocomplete>

                <v-autocomplete
                  v-else
                  v-model="item.inventory_item_id"
                  :items="inventoryItems"
                  item-value="id"
                  :loading="loadingInventoryItem"
                  :item-text="(item) => item.material_id + ': ' + item.name"
                  :rules="[(v) => !!v || 'Inventory Item is required']"
                  :no-data-text="inventoryClassId ? 'No inventory items found' : 'Select a Class first'"
                  clearable
                  @change="onInventoryItemChange"
                >
                  <template slot="label">
                    Inventory Item<RedAsterisk />
                  </template>
                  <template #item="{ item }">
                    <v-chip
                      class="mt-1 mb-1 mr-3"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item && item.classes ? item.classes.color : 'white'"
                    >
                      {{ item && item.classes ? item.classes.name : '' }}
                    </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
                  </template>
                  <template #selection="{ item }">
                    <v-chip
                      class="mt-1 mb-1 mr-3"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item && item.classes ? item.classes.color : 'white'"
                    >
                      {{ item && item.classes ? item.classes.name : '' }}
                    </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3"
                v-if="!isPatioDoorClass"
                class="pb-0"
                :class="{ 'pt-0': businessRulesGetBoolean('Inventory Sub Class') && filteredSubClassesList && filteredSubClassesList.length }"
              >
                <v-autocomplete
                  v-model="item.uom_id"
                  :items="uoms"
                  auto-select-first
                  item-text="name"
                  item-value="id"
                  :loading="loadingUom"
                  :rules="[(v) => !!v || 'UOM is required']"
                  clearable
                >
                  <template slot="label">
                    UOM<RedAsterisk />
                  </template>
                </v-autocomplete>
              </v-col>


            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="4"
                v-if="isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-text-field
                  v-model="item.xo_quantity"
                  prefix="XO:"
                  :rules="[(v) => v !== null && v !== undefined && v !== '' || 'XO Quantity is required', (v) => /^\d+$/.test(v) || 'Please enter a whole number']"
                  step="1"
                  type="number"
                  hint="Enter Quantity for XO Patio Doors"
                  persistent-hint
                >
                  <template slot="label">
                    Quantity<RedAsterisk />
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-text-field
                  v-model="item.ox_quantity"
                  prefix="OX:"
                  :rules="[(v) => v !== null && v !== undefined && v !== '' || 'OX Quantity is required', (v) => /^\d+$/.test(v) || 'Please enter a whole number']"
                  step="1"
                  type="number"
                  hint="Enter Quantity for OX Patio Doors"
                  persistent-hint
                >
                  <template slot="label">
                    Quantity<RedAsterisk />
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.uom_id"
                  :items="uoms"
                  auto-select-first
                  item-text="name"
                  item-value="id"
                  :loading="loadingUom"
                  :rules="[(v) => !!v || 'UOM is required']"
                  clearable
                >
                  <template slot="label">
                    UOM<RedAsterisk />
                  </template>
                </v-autocomplete>
              </v-col>



              <v-col cols="12" sm="6" md="4"
                v-if="isAlloyOptionClass()"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.alloy_id"
                  :items="alloys"
                  item-text="name"
                  item-value="id"
                  clearable
                >
                  <template slot="label">
                    Alloy
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="isTemperingOptionClass()"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.tempering_id"
                  :items="temperings"
                  item-text="name"
                  item-value="id"
                  clearable
                >
                  <template slot="label">
                    Tempering
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="isPaintOnClass()"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.paint_on_option_id"
                  :items="paintOnOptions"
                  item-text="name"
                  item-value="id"
                  clearable
                >
                  <template slot="label">
                    Paint On
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-text-field
                  v-model="item.width"
                  :rules="[(v) => !!v || 'Door width is required']"
                >
                  <template slot="label">
                    Door Width<RedAsterisk />
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-text-field
                  v-model="item.height"
                  :rules="[(v) => !!v || 'Door height is required']"
                >
                  <template slot="label">
                    Door Height<RedAsterisk />
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="g_code"
                  :items="glassItems"
                  item-text="g_code"
                  item-value="g_code"
                  :rules="[(v) => !!v || 'Glass is required']"
                  clearable
                  return-object
                  @change="handleGlassChange"
                >
                  <template slot="label">
                    Glass<RedAsterisk />
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="!isPatioDoorClass && inventoryClassId !== classGlassId && inventoryItemClassId !== classPanelsId"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.length_id"
                  :items="lengths"
                  item-text="name"
                  item-value="id"
                  :disabled="!item.inventory_item_id"
                  :loading="loadingLength"
                  clearable
                >
                  <template slot="label">
                    Length
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="inventoryItemClassId === classPanelsId"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.dimension_unit_id"
                  :items="dimensionUnits"
                  item-text="name"
                  item-value="id"
                  :disabled="!item.inventory_item_id"
                  :loading="loadingDimensionUnit"
                  clearable
                  :rules="isDimensionUnitRequired ? [(v) => !!v || 'Dimension Unit is required'] : []"
                >
                  <template slot="label">
                    Dimension Unit<RedAsterisk v-if="isDimensionUnitRequired" />
                  </template>
                </v-autocomplete>
              </v-col>



              <v-col cols="12"
                v-if="!item.color_ids || item.color_ids.length != 0 || isTypeRepaint"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.color_ids"
                  :items="colors"
                  item-text="code"
                  item-value="id"
                  :clearable="true"
                  :multiple="calculationTypeId === calculationTypeIdLength ? true : false"
                  :loading="loadingColors"
                  :hint="calculationTypeId === calculationTypeIdLength ? 'Picker will choose one of the selected colors' : 'Select color from the list'"
                  persistent-hint
                >
                  <template slot="label">
                    {{ calculationTypeId === calculationTypeIdLength ? 'Repaint From Colors' : 'Color' }}<RedAsterisk v-if="calculationTypeId === calculationTypeIdWeight" />
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12"
                v-if="
                  isTypeRepaint &&
                  businessRulesGetBoolean('Per Item Repaint Pricing')
                "
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.repaint_to_color_id"
                  :items="colors"
                  item-text="code"
                  item-value="id"
                  :clearable="true"
                  :loading="loadingColors"
                  :rules="[(v) => !!v || 'Repaint Color is required']"
                  @change="triggerPriceChange"
                >
                  <template slot="label">
                    Repaint To Color<RedAsterisk />
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12"
                v-if="isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.ex_color_id"
                  :items="colors"
                  item-text="code"
                  item-value="id"
                  :rules="[(v) => !!v || 'Exterior color is required']"
                  :loading="loadingColors"
                  clearable
                >
                  <template slot="label">
                    Exterior Color<RedAsterisk />
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12"
                v-if="isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-autocomplete
                  v-model="item.color_id"
                  :items="colors"
                  item-text="code"
                  item-value="id"
                  :rules="[(v) => !!v || 'Interior color is required']"
                  :loading="loadingColors"
                  clearable
                >
                  <template slot="label">
                    Interior Color<RedAsterisk />
                  </template>
                </v-autocomplete>
              </v-col>

            </v-row>

            <v-row>
              <v-col cols="12" :sm="isPatioDoorClass ? 12 : 8"
                class="pb-0 pt-0"
              >
                <v-text-field
                  v-model="item.price"
                  :rules="[(v) => !!v || 'Unit Price is required']"
                  type="number"
                  :suffix="`${isTax ? `${regionName} HST ${tax}%: $${(item.price * tax / 100).toFixed(2)}` : ''} `"
                  :prefix="`${currency ? currency.symbol: ''}`"
                  min="0"
                  @blur="updateItemPrice"
                >
                  <template slot="label">
                    Unit Price<RedAsterisk />
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="4"
                v-if="!isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-text-field
                  v-model="item.quantity"
                  :rules="[(v) => !!v || 'Quantity is required', (v) => /^\d+$/.test(v) || 'Please enter a whole number']"
                  type="number"
                  step="1"
                  min="0"
                >
                  <template slot="label">
                    Quantity<RedAsterisk />
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>


              <v-col cols="12"
                v-if="isTypeRepaint"
                class="pb-0 pt-0 d-flex align-center flex-wrap"
              >
                <v-checkbox
                  v-model="is_double_price"
                  class="mr-4 flex-shrink-0"
                  style="white-space: nowrap;"
                  label="Double Price"
                  :true-value="1"
                  :false-value="0"
                  @change="handlePriceMultiplierChange('double')"
                />
                <v-checkbox
                  v-model="is_triple_price"
                  class="flex-shrink-0"
                  style="white-space: nowrap;"
                  label="Triple Price"
                  :true-value="1"
                  :false-value="0"
                  @change="handlePriceMultiplierChange('triple')"
                />
              </v-col>

              <v-col cols="12" sm="6" md="4"
                v-if="isPatioDoorClass"
                class="pb-0 pt-0"
              >
                <v-checkbox
                  v-model="item.is_awd_supplied"
                  label="Glass Supplied By AWD"
                  :true-value="1"
                  :false-value="0"
                />
              </v-col>
            </v-row>

            <v-row
              align="center"
              justify="center"
            >
              <v-col
                v-if="isPatioDoorClass"
                cols="6"
                class="pb-0 pt-0"
              >
                <v-radio-group
                  v-model="item.door_screen_id"
                  :rules="[(v) => !!v || 'Door screen selection is required']"
                  :disabled="!item.inventory_item_id"
                >
                  <template #label>
                    <span style="font-size: 1.2em; color: rgba(0, 0, 0, 0.65);">Screen<RedAsterisk /></span>
                  </template>
                  <v-row>
                    <v-col cols="auto">
                      <v-radio
                        label="WITH SCREEN"
                        :value="1"
                      />
                    </v-col>
                    <v-col cols="auto">
                      <v-radio
                        label="WITHOUT SCREEN"
                        :value="2"
                      />
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>

              <v-col
                v-if="isPatioDoorClass"
                cols="6"
                class="pb-0 pt-0"
              >
                <v-radio-group
                  v-model="item.is_fritted"
                  :rules="[(v) => v !== null && v !== undefined && v !== '' || 'Fritted or Non-Fritted selection is required']"
                  :disabled="!!g_code"
                >
                  <template #label>
                    <span style="font-size: 1.2em; color: rgba(0, 0, 0, 0.65);">Fritted<RedAsterisk /> </span>
                    <span style="font-size: .8em; color: rgba(0, 0, 0, 0.65);"> (auto selected from Glass)</span>
                  </template>
                  <v-row>
                    <v-col cols="auto">
                      <v-radio
                        label="FRITTED"
                        :value="1"
                      />
                    </v-col>
                    <v-col cols="auto">
                      <v-radio
                        label="NON-FRITTED"
                        :value="0"
                      />
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="pt-0">
                <v-autocomplete
                  v-if="isSupplierItems"
                  v-model="item.inventory_supplier_item_id"
                  :items="inventorySupplierItems"
                  item-value="id"
                  readonly
                  clearable
                  :loading="loadingInventoryItem"
                  :item-text="(item) => item.material_id + ': ' + item.name"
                  :no-data-text="inventoryClassId ? 'No supplier items found' : 'Select a Class first'"
                  @change="getQuantityOnHand"
                >
                  <template slot="label">
                    Inventory Supplier Item
                  </template>
                  <template #item="{ item }">
                    <v-chip
                      v-if="item.inventory_item"
                      class="mt-1 mb-1 mr-3"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item && item.inventory_item.classes ? item.inventory_item.classes.color : 'white'"
                    >
                      {{ item && item.inventory_item.classes ? item.inventory_item.classes.name : '' }}
                    </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
                  </template>
                  <template #selection="{ item }">
                    <v-chip
                      v-if="item.inventory_item"
                      class="mt-1 mb-1 mr-3"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item && item.inventory_item.classes ? item.inventory_item.classes.color : 'white'"
                    >
                      {{ item && item.inventory_item.classes ? item.inventory_item.classes.name : '' }}
                    </v-chip><span style="font-weight: bold;">{{ item.material_id }}</span><span>{{ ': ' + item.name }}</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pb-0 pt-0">
            <span style="font-size: 18px;">Note</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pt-0 pb-0">
            <v-textarea
              v-model="item.note"
              outlined
              rows="3"
            />
          </v-col>
        </v-row>

        <v-row v-if="!isPatioDoorClass">
          <v-col class="pt-20 pb-20">
            <InventoryPoItemFormCurrentAndDangerLevelTable
              :inventory-item-id="item.inventory_item_id || item.glass_paint_code_id"
              :inventory-class-id="inventoryClassId"
              :locations="locations"
            />
          </v-col>
        </v-row>
      </template>
    </the-dialog-box>

    <inventory-item-show-image-form ref="itemShowImageForm" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import InventoryItemShowImageForm from '@/components/forms/InventoryItemShowImageForm';
import InventoryPoItemFormCurrentAndDangerLevelTable from '@/components/forms/inventoryPos/InventoryPoItemFormCurrentAndDangerLevelTable';
import * as ValidationHelpers from '@/helpers/ValidationHelpers';

export default {
  components: {
    InventoryItemShowImageForm,
    InventoryPoItemFormCurrentAndDangerLevelTable,
  },
  props: {
    isTax: {
      type: Number,
      default: 1,
    },
    currency: {
      type: Object,
      default: null,
    },
    glassItems: {
      type: Array,
      default: () => [],
    },
    poItems: {
      type: Array,
      default: () => [],
    },
    supplierId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      inventory_item_id: null,
      glass_paint_code_id: null,
      uom_id: null,
      quantity: null,
      price: null,
      note: null,
      temp_id: null,
      length_id: null,
      color_ids: [],
      tempering_id: null,
      alloy_id: null,
      color_id: null,
      ex_color_id: null,
      height: null,
      width: null,
      glass: {},
      is_fritted: null,
      door_screen_id: 1,
      paint_on_option_id: null,
      ox_quantity: null,
      xo_quantity: null,
      dimension_unit_id: null,
      repaint_to_color_id: null,
    },

    uoms: [],
    colors: [],
    lengths: [],
    locations: [],
    inventoryItems: [],
    glassPaintCodes: [],
    colorPrices: [],
    inventoryTags: [],
    alloys: [],
    temperings: [],
    doorScreens: [],
    dimensionUnits: [],

    quantityOnHand: 0,
    class4500Id: 1,
    class4800Id: 2,
    classRailingsId: 3,
    classInstId: 4,
    classGlassId: 5,
    classCommercialId: 6,
    classVWDGlass: 7,
    classPanelsId: 8,
    classSidgId: 9,
    classIdRailParts: 10,
    classPartsId: 11,
    classPaintId: 12,
    classEquipmentId: 13,
    classPatioDoorId: 14,
    classEuroDoorId: 15,
    classMedicalAidId: 16,
    classFacadesId: 17,
    class6000Id: 18,
    classServiceId: 19,
    classOtherId: 20,
    isNew: false,
    loadingLength: false,
    loadingDimensionUnit: false,
    colorPrice: null,
    colorPriceIdMillFinish: 1,
    isInit: false,
    inventoryClassId: null,
    inventoryItemClassId: null,
    loadingInventoryItem: false,
    loadingUom: false,
    typeIdNew: 1,
    typeIdRepaint: 2,
    inventoryPoTypes: [],
    loadingColors: false,
    inventoryPoTypeIds: [],
    isTypeRepaint: false,

    classMap: {},
    subClassesList: [],
    filteredSubClassesList: [],
    classToSubclassesMap: {},
    subClasses: [],

    colorIdMillFinish: 9,
    calculationTypeId: null,
    calculationTypeIdLength: 1,
    calculationTypeIdWeight: 2,
    paintOnOptions: [],
    inventorySupplierItems: [],

    currentLevel: null,
    dangerLevel: null,
    uomIdBucket: 9,
    uomIdEach: 13,
    g_code: null,
    regionName: null,
    organizationName: null,
    tax: 0.13,
    isSupplierItems: false,

    is_double_price: false,
    is_triple_price: false,
  }),
  computed: {
    inventoryClass() {
      return this.classMap[this.inventoryClassId] || null;
    },
    lencolToggle() {
      return this.$store.getters['businessRulesGetBoolean']('Add Length And Color');
    },
    ...mapState({
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    filterHistoryRecordTypeId() {
      if (this.inventoryClassId === this.class4500Id || this.inventoryClassId === this.class4800Id || this.inventoryClassId === this.classCommercialId || this.inventoryClassId === this.classSidgId) return this.historyRecordTypeQrCodeId;
      if (this.inventoryClassId === this.classPartsId || this.inventoryClassId === this.classPaintId) return this.historyRecordTypeUpcCodeId;
      return this.historyRecordTypeQrCodeId;
    },
    isPatioDoorClass() {
      return this.inventoryClassId === this.classPatioDoorId;
    },
    getUomIdMap() {
      return {
        [this.classPaintId]: this.uomIdBucket,
        [this.classPatioDoorId]: this.uomIdEach,
      };
    },
    isDimensionUnitRequired() {
      // Tenant override: Aluminum Window Designs Facades requires Dimension Unit
      const orgName = (this.$store && this.$store.getters && this.$store.getters.organizationName) || this.organizationName;
      if (orgName && orgName.trim().toLowerCase() === 'aluminum window designs facades') return true;

      const rule = this.businessRulesGetBoolean('Require Dimension Unit');
      if (rule === 1 || rule === true) return true;
      if (rule === 0 || rule === false) return false;
      return this.inventoryItemClassId === this.classPanelsId;
    },
  },
  watch: {
    'item.inventory_item_id': function () {
      this.getUoms();
      this.getDimensionUnits();
      if (this.isInit) return;
      this.triggerPriceChange();
    },
    'item.inventory_supplier_item_id': function (newValue, oldValue) {
      if (this.isInit || (newValue === null && oldValue !== null)) return;
      this.triggerPriceChange();
    },
    'item.length_id': function () {
      if (this.isInit) return;
      const changedData = {
        length_id : this.item.length_id,
      }
      this.triggerPriceChange(changedData);
    },
    'item.dimension_unit_id': function () {
      if (this.isInit) return;
      const changedData = {
        dimension_unit_id : this.item.dimension_unit_id,
      }
      this.triggerPriceChange(changedData);
    },
    'item.color_ids': function () {
      if (this.isInit) return;
      this.triggerPriceChange();
    },
    inventoryClassId(value) {
      if (this.isInit) return;
      this.filteredSubClassesList = value ? this.classToSubclassesMap[value] : this.subClassesList;
      this.getInventoryItems();
    },
    subClasses() {
      if (!this.businessRulesGetBoolean('Inventory Sub Class')) return;
      this.getInventoryItems();
    }
  },
  created() {
    this.item = { ...this.itemDto };
    this.getOrganization();
    this.isSupplierItems = this.businessRulesGetBoolean('Inventory Po Supplier Item') === 1;
  },
  methods: {
    async getClasses() {
      this.classMap = this.$store.state.invClasses.reduce((acc, x) => {
        acc[x.id] = x;
        return acc;
      }, {});
    },
    async getSubClasses() {
      this.subClassesList = await this.$api.inventorySubClass.getList();
      this.classToSubclassesMap = this.subClassesList.reduce((acc, x) => {
        if (!(x.inventory_class_id in acc)) acc[x.inventory_class_id] = [];
        acc[x.inventory_class_id].push(x);
        return acc;
      }, {});
      this.filteredSubClassesList = this.inventoryClassId ? this.classToSubclassesMap[this.inventoryClassId] : this.subClassesList;
    },

    async getLocations() {
      const res = await this.$api.location.get();
      if (!res) return;
      this.locations = res;
    },

    async getUoms() {
      const uomId = this.getUomIdMap[this.inventoryClassId] || null;

      let inventoryItemId = this.item.inventory_item_id;
      if (this.inventoryClassId === this.classPaintId || this.inventoryClassId === this.classPatioDoorId) {
        inventoryItemId = null;
      }

      const submitData = {
        filters: {
          id: uomId,
          inventory_item_id: inventoryItemId,
        },
      };
      this.uoms = await this.$api.uom.read(submitData);
      if (this.uoms.length === 1) {
        this.item.uom_id = this.uoms[0].id;
      }
    },

    async getDimensionUnits() {
      this.loadingDimensionUnit = true;
      const uomCategoryIdArea = 2;
      const submitData = {
        filters: {
          uom_category_id: uomCategoryIdArea,
        },
      };
      this.dimensionUnits = await this.$api.uom.read(submitData);
      this.loadingDimensionUnit = false;
      if (this.dimensionUnits.length === 1) {
        this.item.dimension_unit_id = this.dimensionUnits[0].id;
      }
    },

    async getInventoryItems() {
      this.loadingInventoryItem = true;
      this.inventoryItems = [];
      const readModel = {
        filters: {
          inventory_class_id: this.inventoryClassId,
        },
        includes: {
          is_include_parameters: true,
        },
      };

      if (this.businessRulesGetBoolean('Inventory Sub Class')) {
        readModel.filters.inventory_sub_class_ids = this.subClasses; //TODO test this
      }

      const res = await this.$api.inventoryItem.readData(readModel);
      this.loadingInventoryItem = false;
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.inventoryItems = [];
        return;
      }
      this.inventoryItems = res.data;
    },

    async getGlassPaintCodes() {
      this.loading = true;
      const submitModel = {
        filters: {
          is_awd_paint: true,
        },
      };
      this.glassPaintCodes = await this.$api.glassPaintCode.read(submitModel);
      this.loading = false;
    },

    async getLengths() {
      this.loadingLength = true;
      const submitData = {
        filters: {
          inventory_item_id: this.item ? this.item.inventory_item_id : null,
          inventory_class_id: this.item.inventory_class_id,
        },
      };
      this.lengths = await this.$api.length.read(submitData);
      this.loadingLength = false;
    },

    async getTypes() {
      this.inventoryPoTypes = await this.$api.inventoryPoType.get();
    },

    async getColors() {
      this.loadingColors = true;
      const submitModel = { filters: {} };
      this.colors = await this.$api.color.read(submitModel);
      this.loadingColors = false;
    },

    async getColorPrices() {
      const submitModel = { filters: {} };
      this.colorPrices = await this.$api.inventoryPoColorPrice.read(submitModel);
    },

    onInventoryItemChange(inventoryItemId) {
      this.getQuantityOnHand(inventoryItemId);
      //find the inventory item from inventoryItems using inventoryItemId and set this.inventoryItemClassId to the inventory item's class
      const inventoryItem = this.inventoryItems.find((x) => x.id === inventoryItemId);
      if (inventoryItem) {
        this.inventoryItemClassId = inventoryItem.inventory_class_id;
      } else {
        this.inventoryItemClassId = null;
      }
    },

    async getQuantityOnHand(selectedId) {
      if (!selectedId) {
        this.subClasses = [];
        return;
      }

      await this.getInventoryTags(selectedId);

      const picked =
        this.inventoryTags.find((x) => x.item && x.item.id === selectedId) || null;

      if (!this.subClassesList || this.subClassesList.length === 0) {
        await this.getSubClasses();
      }

      //TODO not sure what the code above does or if its necessary. Dont have the time to verify it now
      const pickedItem = this.inventoryItems.find(x => x.id === Number(selectedId));

      if (pickedItem !== null && pickedItem.inventory_sub_classes) {
        this.subClasses = pickedItem.inventory_sub_classes.map(x => x.id);
      } else {
        this.subClasses = [];
      }
    },

    async getInventoryTags(selectedId) {
      const submitModel = {
        filters: {
          inventory_item_id: selectedId,
          is_qty_on_hand_o: 0,
        },
      };
      const res = await this.$api.inventoryTag.read(submitModel);
      if (!res || !res.data) return;
      this.inventoryTags = res.data;
    },

    async getAlloys() {
      const submitData = {
        filters: {
          inventory_class_id: this.inventoryClassId === this.classPanelsId ? this.inventoryClassId : null,
        },
      };
      this.alloys = await this.$api.alloy.read(submitData);
    },

    async getTemperings() {
      const submitData = {
        filters: {
          inventory_class_id: this.inventoryClassId === this.classPanelsId ? this.inventoryClassId : null,
        },
      };
      this.temperings = await this.$api.tempering.read(submitData);
    },

    async getDoorScreens() {
      this.doorScreens = await this.$api.doorScreen.get();
    },

    async getPaintOnOptions() {
      this.paintOnOptions = await this.$api.paintOnOption.get();
    },

    async getOrganization() {
      const res = await this.$api.organization.get();
      if (!res || res.length === 0) return;
      this.tax = res[0].tax;
      this.regionName = res[0].region.name || null;
    },

    async getSupplierItems() {
      if (!this.item.inventory_item_id || !this.supplierId) {
        this.inventorySupplierItems = [];
        this.item.inventory_supplier_item_id = null;
        return;
      }
      const submitModel = {
        filters: {
          class_id: this.inventoryClassId,
          inventory_item_id: this.item.inventory_item_id,
          supplier_id: this.supplierId,
        },
      };
      const res = await this.$api.inventorySupplierItem.read(submitModel);
      if (!res || !res.data || res.data.length === 0) {
        this.inventorySupplierItems = [];
        this.item.inventory_supplier_item_id = null;
        if (this.isInit) return;
        const inventoryItem = this.inventoryItems.find((x) => x.id === this.item.inventory_item_id);
        if (!inventoryItem || !inventoryItem.price) return;
        this.item.price = inventoryItem.price;
        return;
      }
      this.inventorySupplierItems = res.data;
      if (this.inventorySupplierItems.length > 0) {
        this.item.inventory_supplier_item_id = this.inventorySupplierItems[0].id;
        if (this.isInit) return;
        this.item.price = this.inventorySupplierItems[0].price;
      }
    },

    getClassColWidth() {
      if (!this.inventoryClass) return 1;
      const classNameLength = this.inventoryClass.name.length;
      if (classNameLength < 6) return 1;
      else if (classNameLength < 12) return 2;
      return 3;
    },

    async submit() {
      if (this.isPatioDoorClass) {
        const item = JSON.parse(JSON.stringify(this.item));
        const poItems = JSON.parse(JSON.stringify(this.poItems));
        const patioDoorItem = this.existingPatioDoorItem(item, poItems);

        if (patioDoorItem !== null) {
          this.$bus.$emit('showError', 'This Patio Door item already exists in the PO with the same specifications. Please modify the existing entry.');
          return false;
        }

        const hasValidDimensions = this.isDecimalInFractions(item.width) && this.isDecimalInFractions(item.height);
        if (!hasValidDimensions) {
          this.$bus.$emit('showError', 'Incorrect Width or Height value');
          return false;
        }
      }

      if (this.item.inventory_item_id) {
        const inventoryItem = this.inventoryItems.find((x) => x.id === this.item.inventory_item_id);
        if (inventoryItem) {
          this.item.item_code = inventoryItem.material_id;
          this.item.item_name = inventoryItem.name;
          this.item.weight = inventoryItem.weight;
          this.item.inventory_class_id = inventoryItem.inventory_class_id;
        }
      }

      if (this.item.inventory_supplier_item_id) {
        const supplierItem = this.inventorySupplierItems.find((x) => x.id === this.item.inventory_supplier_item_id);
        if (supplierItem) {
          this.item.item_supplier_code = supplierItem.material_id;
          this.item.item_supplier_name = supplierItem.name;
          this.item.inventory_supplier_item = supplierItem;
        }
      } else {
        this.item.item_supplier_code = null;
        this.item.item_supplier_name = null;
        this.item.inventory_supplier_item = null;
      }

      if (this.item.glass_paint_code_id) {
        const glassPaintCode = this.glassPaintCodes.find((x) => x.id === this.item.glass_paint_code_id);
        if (glassPaintCode) {
          this.item.item_code = glassPaintCode.code;
          this.item.item_name = glassPaintCode.description;
        }
      }

      if (this.item.uom_id) {
        const uom = this.uoms.find((x) => x.id === this.item.uom_id);
        if (uom) this.item.uom_name = uom.name;
      }

      if (this.item.length_id) {
        const length = this.lengths.find((x) => x.id === this.item.length_id);
        if (length) this.item.length_name = length.name;
      }

      if (this.calculationTypeId === this.calculationTypeIdLength) {
        const colors = this.colors.filter((x) => this.item.color_ids.includes(x.id));
        if (colors) this.item.color_names = colors.map((x) => x.code).join(', ');
      } else {
        const colors = this.colors.find((x) => x.id === this.item.color_ids);
        if (colors) this.item.color_names = colors.code;
      }

      if (this.item.color_id) {
        const color = this.colors.find((x) => x.id === this.item.color_id);
        if (color) this.item.color = color;
      }

      if (this.item.ex_color_id) {
        const color = this.colors.find((x) => x.id === this.item.ex_color_id);
        if (color) this.item.ex_color = color;
      }

      if (this.item.repaint_to_color_id) {
        const repaintToColor = this.colors.find((x) => x.id === this.item.repaint_to_color_id);

        if (repaintToColor) {
          this.item.repaint_to_color = repaintToColor;
          this.item.repaint_to_color_code = repaintToColor.code;
          this.item.repaint_to_color_name = repaintToColor.name;
        }
      } else {
        this.item.repaint_to_color = null;
        this.item.repaint_to_color_code = null;
        this.item.repaint_to_color_name = null;
      }

      if (this.item.dimension_unit_id) {
        const dimensionUnit = this.dimensionUnits.find((x) => x.id === this.item.dimension_unit_id);
        if (dimensionUnit) {
          this.item.dimension_unit = dimensionUnit;
        } else {
          this.item.dimension_unit = null;
        }
      }

      if (this.item.door_screen_id) {
        const doorScreen = this.doorScreens.find((x) => x.id === this.item.door_screen_id);
        if (doorScreen) this.item.door_screen = doorScreen;
      }

      if (this.isPatioDoorClass) {
        this.item.quantity = (parseInt(this.item.xo_quantity, 10) || 0) + (parseInt(this.item.ox_quantity, 10) || 0);
      }
      this.item.inventory_sub_class_ids = this.subClasses;

      this.item.glass = JSON.parse(JSON.stringify(this.item.glass));
      this.item.total = this.item.quantity * this.item.price;
      this.$bus.$emit('showSuccess');

      const itemCopy = JSON.parse(JSON.stringify(this.item));
      this.$emit('success', itemCopy);
      return true;
    },

    updateItemPrice() {
      if (this.isSupplierItems && this.item.inventory_supplier_item_id) {
        this.updateSupplierItemPrice();
        return;
      }
      if (this.isSupplierItems) {
        const submitModel = { id: this.item.inventory_item_id, price: this.item.price };
        this.$api.inventoryItem.update(submitModel, 'price');
        return;
      }
      if (this.inventoryClassId !== this.classPartsId) return;
      const submitModel = { id: this.item.inventory_item_id, price: this.item.price };
      this.$api.inventoryItem.update(submitModel, 'price');
    },

    updateSupplierItemPrice() {
      const submitModel = { id: this.item.inventory_supplier_item_id, price: this.item.price };
      this.$api.inventorySupplierItem.update(submitModel, 'price');
    },

    async open(item, inventoryClassId, inventoryPoTypeIds, colorPrice, calculationTypeId, openReceive = false) {
      this.isInit = true;
      this.isTypeRepaint = false;
      this.inventoryClassId = inventoryClassId;
      this.colorPrice = colorPrice;
      this.isTypeRepaint = inventoryPoTypeIds.includes(this.typeIdRepaint);
      this.calculationTypeId = calculationTypeId;
      this.currentLevel = null;

      this.subClasses = [];
      this.getClasses();
      this.getSubClasses();

      this.$refs.dialogBox.open();

      if (item) {
        this.item = { ...item };

        if (this.item.inventory_item) {
          this.inventoryItemClassId = this.item.inventory_item.inventory_class_id;
        } else {
          this.inventoryItemClassId = this.item.inventory_class_id || null;
        }

        if (calculationTypeId === this.calculationTypeIdWeight) {
          this.item.color_ids = item.color_ids;
        }
        this.g_code = this.item.glass ? this.item.glass.g_code : null;
        this.isNew = false;

        this.subClasses = this.item && this.item.inventory_item && Array.isArray(this.item.inventory_item.sub_classes) ? this.item.inventory_item.sub_classes.map((sc) => (typeof sc === 'object' ? sc.id : sc)) : [];
      } else {
        this.item = { ...this.itemDto };
        this.item.temp_id = Date.now();

        if (inventoryClassId === this.classPaintId) {
          this.item.uom_id = this.uomIdBucket;
        } else if (inventoryClassId === this.classPatioDoorId) {
          this.item.uom_id = this.uomIdEach;
        }

        this.isNew = true;

        if (this.isTypeRepaint) {
          const colorIdMillFinish = 9;
          this.item.color_ids = [colorIdMillFinish];
        }

      }

      if (this.isSupplierItems) {
        await this.getSupplierItems();
      }

      this.$nextTick(async () => {
        this.isInit = false;
      });

      this.getInventoryItems();
      this.getUoms();
      this.getLengths();
      this.getTypes();
      this.getColors();
      this.getColorPrices();
      this.getGlassPaintCodes();
      this.getAlloys();
      this.getTemperings();
      this.getDoorScreens();
      this.getLocations();
      this.getPaintOnOptions();
    },

    openGlassPoItemForm(item) {
      this.$refs.glassPoItemForm.open(item, null, true);
    },

    handleGlassChange(item) {
      if (!item) return;
      this.item.glass = item;
      this.g_code = item.g_code;
      this.item.is_fritted = item.glass && item.glass.fritted ? 1 : 0;
    },

    // triggerPriceChange(changedData = null) {
    //   if (this.isSupplierItems) {
    //     if (changedData && changedData.length_id && this.calculationTypeId === this.calculationTypeIdLength) {
    //       this.triggerPriceChangeLength();
    //     } 
    //     else if (changedData && changedData.dimension_unit_id) {
    //       this.triggerPriceChangeDimensionUnit();
    //     }
    //     else {
    //       this.getSupplierItems();
    //     }
    //   } else if (this.inventoryClassId === this.classPartsId) {
    //     this.findItemPrice();
    //   } else if (this.calculationTypeId === this.calculationTypeIdLength) {
    //     if (changedData && changedData.length_id) {
    //       this.triggerPriceChangeLength();
    //     } 
    //     else if (changedData && changedData.dimension_unit_id) {
    //       this.triggerPriceChangeDimensionUnit();
    //     }
    //     else {
    //       this.triggerPriceChangeLength();
    //     }
    //   } else {
    //     this.triggerPriceChangeWeight();
    //   }
    // },

    triggerPriceChange(changedData = null) {
      if (this.isSupplierItems) {
        this.triggerSupplierItemPriceChange();
        return;
      }

      if (this.inventoryClassId === this.classPartsId) {
        this.findItemPrice();
        return;
      }

      if (this.calculationTypeId === this.calculationTypeIdWeight) {
        this.triggerPriceChangeWeight();
        return;
      }

      if (this.shouldUseDimensionPricing()) {
        this.triggerPriceChangeDimensionUnit();
        return;
      }

      this.triggerPriceChangeLength();
    },

    shouldUseDimensionPricing() {
      return this.inventoryItemClassId === this.classPanelsId;
    },

    triggerSupplierItemPriceChange() {
      if (this.shouldUseDimensionPricing()) {
        this.triggerPriceChangeDimensionUnit();
        return;
      }

      if (this.calculationTypeId === this.calculationTypeIdLength) {
        this.triggerPriceChangeLength();
        return;
      }

      this.getSupplierItems();
    },

    findItemPrice() {
      if (!this.item.inventory_item_id) return;
      const inventoryItem = this.inventoryItems.find((x) => x.id === this.item.inventory_item_id);
      if (!inventoryItem || inventoryItem.inventory_class_id !== this.classPartsId || !inventoryItem.price) return;
      this.item.price = inventoryItem.price;
    },

    async triggerPriceChangeLength() {
      console.log('triggerPriceChangeLength with length_id:', this.item.length_id, 'colorPrice:', this.colorPrice);

      if (!this.item.length_id) return;

      const length = this.lengths.find((x) => x.id === this.item.length_id);

      console.log('length found:', length);

      if (!length) {
        this.item.price = 0;
        return;
      }

      //get the value and uom_id from something like 18 ft.
      const parsedLength = await this.$api.uom.store({
        value: length.name,
      }, 'parse-value-and-uom');

      if (!parsedLength) {
        this.item.price = 0;
        return;
      }

      let colorPrice = null;

      console.log('isTypeRepaint:', this.isTypeRepaint);

      if (this.isTypeRepaint) {
        let additionalExpense = 0;

        if (this.businessRulesGetBoolean('Per Item Repaint Pricing')) {
          const repaintColor = this.colors.find((x) => x.id === this.item.repaint_to_color_id);

          if (!repaintColor) {
            this.item.price = 0;
            return;
          }

          colorPrice = this.colorPrices.find((x) =>
            repaintColor.code.toUpperCase().includes(x.code.toUpperCase())
          );

          if (!colorPrice) {
            this.item.price = 0;
            return;
          }
        } else {
          colorPrice = this.colorPrice;
        }

        if (this.item.color_ids.includes(this.colorIdMillFinish)) {
          additionalExpense = 0;
        } else {
          additionalExpense = colorPrice.additional_expense;
        }

        //default length
        let convertedLength = parsedLength.value;

        console.log('Parsed Length Uom Id:', parsedLength.uom_id, 'Color Price Uom Id:', colorPrice.extrusion_price_uom_id);

        // length.uom_id = unit of the selected length
        // colorPrice.extrusion_price_uom_id = unit used by the extrusion price
        if (
          parsedLength.uom_id &&
          colorPrice.extrusion_price_uom_id &&
          parsedLength.uom_id !== colorPrice.extrusion_price_uom_id
        ) {
          const submitModel = {
            value: parsedLength.value,
            from_uom_id: parsedLength.uom_id,
            to_uom_id: colorPrice.extrusion_price_uom_id,
          };

          const res = await this.$api.uom.store(submitModel, 'convert');

          if (!res) {
            this.item.price = 0;
            return;
          }

          convertedLength = parseFloat(res);
        }

        console.log(
          'calculating price with length:',
          convertedLength,
          'color price:',
          colorPrice.extrusion_price,
          'additional expense:',
          additionalExpense
        );

        let price = convertedLength * (colorPrice.extrusion_price + additionalExpense);

        if (this.is_double_price) {
          price *= 2;
        }

        if (this.is_triple_price) {
          price *= 3;
        }

        this.item.price = parseFloat(price.toFixed(5));
      }
    },

    async triggerPriceChangeDimensionUnit() {
      console.log('triggerPriceChangeDimensionUnit with dimension_unit_id:', this.item.dimension_unit_id, 'colorPrice:', this.colorPrice);

      if (!this.item.dimension_unit_id || !this.item.inventory_item_id) return;

      const inventoryItem = this.inventoryItems.find((x) => x.id === this.item.inventory_item_id);

      if (!inventoryItem || !inventoryItem.name) {
        this.item.price = 0;
        return;
      }

      const dimensionMatch = inventoryItem.name.match(/\[(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)\]/i);

      if (!dimensionMatch) {
        this.item.price = 0;
        return;
      }

      const width = parseFloat(dimensionMatch[1]);
      const height = parseFloat(dimensionMatch[2]);

      if (isNaN(width) || isNaN(height)) {
        this.item.price = 0;
        return;
      }

      let colorPrice = null;

      console.log('isTypeRepaint:', this.isTypeRepaint);

      if (this.isTypeRepaint) {
        let additionalExpense = 0;

        if (this.businessRulesGetBoolean('Per Item Repaint Pricing')) {
          const repaintColor = this.colors.find((x) => x.id === this.item.repaint_to_color_id);

          if (!repaintColor) {
            this.item.price = 0;
            return;
          }

          colorPrice = this.colorPrices.find((x) =>
            repaintColor.code.toUpperCase().includes(x.code.toUpperCase())
          );

          if (!colorPrice) {
            this.item.price = 0;
            return;
          }
        } else {
          colorPrice = this.colorPrice;
        }

        if (!colorPrice) {
          this.item.price = 0;
          return;
        }

        if (this.item.color_ids.includes(this.colorIdMillFinish)) {
          additionalExpense = 0;
        } else {
          additionalExpense = colorPrice.additional_expense;
        }

        let convertedArea = width * height;

        console.log('Area:', convertedArea, 'Dimension Unit Id:', this.item.dimension_unit_id, 'Color Sheet Price Uom Id:', colorPrice.sheet_price_uom_id);

        if (
          this.item.dimension_unit_id &&
          colorPrice.sheet_price_uom_id &&
          this.item.dimension_unit_id !== colorPrice.sheet_price_uom_id
        ) {
          const submitModel = {
            value: convertedArea,
            from_uom_id: this.item.dimension_unit_id,
            to_uom_id: colorPrice.sheet_price_uom_id,
          };

          const res = await this.$api.uom.store(submitModel, 'convert');

          if (!res) {
            this.item.price = 0;
            return;
          }

          convertedArea = parseFloat(res);
        }

        console.log(
          'calculating price with area:',
          convertedArea,
          'sheet price:',
          colorPrice.sheet_price,
          'additional expense:',
          additionalExpense
        );

        let price = convertedArea * (colorPrice.sheet_price + additionalExpense);

        if (this.is_double_price) {
          price *= 2;
        }

        if (this.is_triple_price) {
          price *= 3;
        }

        this.item.price = parseFloat(price.toFixed(5));
      }
    },

    triggerPriceChangeWeight() {
      if (!this.item.inventory_item_id || !this.item.color_ids) return;
      const inventoryItem = this.inventoryItems.find((x) => x.id === this.item.inventory_item_id);
      if (!inventoryItem) {
        this.item.price = 0;
        return;
      }
      const { weight } = inventoryItem;
      if (isNaN(weight) || !weight) {
        this.item.price = 0;
        return;
      }

      const length = this.lengths.find((x) => x.id === this.item.length_id);
      if (!length) {
        this.item.price = 0;
        return;
      }
      const lengthNumber = length.name.split(' ')[0];
      if (isNaN(lengthNumber) || !lengthNumber) {
        this.item.price = 0;
        return;
      }
      const lengthNumberInMeter = lengthNumber * 0.3048;
      const itemLengthPrice = weight * lengthNumberInMeter;

      const color = this.colors.find((x) => x.id === this.item.color_ids);
      if (!color) return;
      const colorPrice = this.colorPrices.find((x) => color.code.toUpperCase().includes(x.code.toUpperCase()));

      const millFinishColorPrice = this.colorPrices.find((x) => x.id === this.colorPriceIdMillFinish);
      if (!millFinishColorPrice) {
        this.item.price = 0;
        return;
      }

      let dieColorPrice = 0;
      if (inventoryItem.material_id.substring(0, 2) === 'AH') {
        dieColorPrice = millFinishColorPrice.inventory_hollow_price;
      } else if (inventoryItem.material_id.substring(0, 2) === 'AS') {
        dieColorPrice = millFinishColorPrice.inventory_solid_price;
      } else {
        this.item.price = 0;
      }

      let price = itemLengthPrice * dieColorPrice;

      if (colorPrice.id !== this.colorPriceIdMillFinish) {
        let paintingColorPrice = 0;

        if (inventoryItem.material_id.substring(0, 2) === 'AH') {
          paintingColorPrice = colorPrice.inventory_hollow_price;
        } else if (inventoryItem.material_id.substring(0, 2) === 'AS') {
          paintingColorPrice = colorPrice.inventory_solid_price;
        } else {
          this.item.price = 0;
        }

        price += (lengthNumberInMeter * paintingColorPrice);
      }

      if (this.is_double_price) {
        price *= 2;
      }

      if (this.is_triple_price) {
        price *= 3;
      }

      this.item.price = parseFloat(price.toFixed(5));
    },

    handlePriceMultiplierChange(type) {
      let price = parseFloat(this.item.price);

      if (isNaN(price)) {
        this.item.price = 0;
        return;
      }

      if (type === 'double') {
        if (this.is_double_price) {
          if (this.is_triple_price) {
            price = price / 3;
            this.is_triple_price = false;
          }

          price = price * 2;
        } else {
          price = price / 2;
        }
      }

      if (type === 'triple') {
        if (this.is_triple_price) {
          if (this.is_double_price) {
            price = price / 2;
            this.is_double_price = false;
          }

          price = price * 3;
        } else {
          price = price / 3;
        }
      }

      this.item.price = parseFloat(price.toFixed(5));
    },

    existingPatioDoorItem(item, poItems) {
      const existingItem = poItems.find((poItem) => {
        if (poItem.temp_id && item.temp_id && poItem.temp_id === item.temp_id) return false;
        if (poItem.xo_id && item.xo_id && poItem.xo_id === item.xo_id) return false;
        if (poItem.ox_id && item.ox_id && poItem.ox_id === item.ox_id) return false;

        const baseMatch = poItem.width == item.width
          && poItem.height == item.height
          && poItem.uom_id === item.uom_id
          && poItem.ex_color_id === item.ex_color_id
          && poItem.color_id === item.color_id
          && poItem.door_screen_id === item.door_screen_id
          && poItem.is_fritted === item.is_fritted
          && poItem.is_awd_supplied === item.is_awd_supplied
          && poItem.price == item.price;

        const glassMatch = !item.glass || (poItem.glass && poItem.glass.g_code == item.glass.g_code);

        const noteMatch = (poItem.note || '').trim() === (item.note || '').trim();

        return baseMatch && glassMatch && noteMatch;
      });

      return existingItem || null;
    },

    isDecimalInFractions(decimalNumber) {
      return ValidationHelpers.isDecimalInFractions(decimalNumber);
    },

    isTemperingOptionClass() {
      return [
        this.classPanelsId,
        this.class4500Id,
        this.class4800Id,
        this.classRailingsId,
        this.classCommercialId,
      ].includes(this.inventoryClassId);
    },

    isAlloyOptionClass() {
      return [
        this.classPanelsId,
        this.class4500Id,
        this.class4800Id,
        this.classRailingsId,
        this.classCommercialId,
      ].includes(this.inventoryClassId);
    },

    isPaintOnClass() {
      return [
        this.classRailingsId,
        this.classIdRailParts,
        this.classPanelsId,
      ].includes(this.inventoryClassId);
    },
  },
};
</script>
